import React from "react";
import { Modal } from "react-bootstrap";
import warning from "../assets/images/warning.svg";

function ConfirmationPopup(props) {
    const { show, onHide, title, message, onConfirm, confirmText = "Yes", cancelText = "No" } = props;

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}>
                <div className="modal-staff" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
                    <img src={warning} alt=".." />
                    <h5 style={{
                        fontSize: "14px",
                        padding: "15px",
                        margin: "0",
                        textAlign: "center",
                        lineHeight: "1.4"
                    }}>
                        {message || "Are you sure you want to update the merge hide setting?"}
                    </h5>
                </div>
                <br />
                <div className="txt-center">
                    <button onClick={onHide} className="no">
                        {cancelText}
                    </button>
                    <button className="okay" style={{ backgroundColor: "green", }} onClick={() => {
                        onConfirm();
                        onHide();
                    }}>
                        {confirmText}
                    </button>

                </div>
            </Modal>
        </>
    );
}

export default ConfirmationPopup; 